import {uniqBy} from "lodash";


export const price = (num) => {
	return parseFloat((num * 100) / 100).toFixed(2).toString().replace(".", ",") + ",-";
};


export const products = ({items}) => {
	// all unique products
	let products = items.reduce((array, item) => uniqBy([...array, item.variant.product], "id"), []);

	// find items with product id
	return products.map(product => ({
		...product,
		line_items: items.filter(x => x.variant.product_id === product.id)
	}));
};


export const thumb = ({url, size}) => {
	if (url && size) {
		const lastIndex = url.lastIndexOf(".");
		return url.substr(0, lastIndex) + `_${size}x${size}_cropped` + url.substr(lastIndex);
	}
};


export const date = (timestamp) => {
	const d = new Date(timestamp * 1000);
	const zero = (val) => ("0" + val).slice(-2);

	return {
		seconds: zero(d.getSeconds()),
		minutes: zero(d.getMinutes()),
		hours: zero(d.getHours()),
		day: zero(d.getDate()),
		month: zero(d.getMonth() + 1),
		year: d.getFullYear(),
		string: d.toLocaleDateString()
	};
};
